/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_6_SolutionInputs */

const et_portfolio_project_6_solution = /** @type {(inputs: Portfolio_Project_6_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehitasime kaasaegse, konversioonile suunatud lehe, mis sobitus nende AI-positsioneerimisega ja optimeerisime kasutajavoo.`)
};

const en_portfolio_project_6_solution = /** @type {(inputs: Portfolio_Project_6_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built a modern, conversion-focused site aligned with their AI positioning and optimized user flow.`)
};

/**
* | output |
* | --- |
* | "Built a modern, conversion-focused site aligned with their AI positioning and optimized user flow." |
*
* @param {Portfolio_Project_6_SolutionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_6_solution = /** @type {((inputs?: Portfolio_Project_6_SolutionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_6_SolutionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_6_solution(inputs)
	return en_portfolio_project_6_solution(inputs)
});